export interface VideoArticle {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  description: string;
  summary: string;
  content: string;
  views: number;
  likes: number;
  rating: number;
  tags: string[];
  publishDate: string;
  isFeatured: boolean;
  isNew: boolean;
  author: string;
}

export const videos: VideoArticle[] = [
  {
    id: 'v001',
    title: '《繁花》—— 王家卫镜头下的上海滩传奇',
    slug: 'fanhua-wangjiawei-shanghai',
    category: '电视剧',
    categorySlug: 'dianshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20old%20Shanghai%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20vintage%201990s%20Shanghai%20aesthetic%20with%20warm%20golden%20tones%2C%20artistic%20cinematography%20style%2C%20atmospheric%20mood%2C%20soft%20bokeh%20background%2C%20film%20grain%20texture%2C%20nostalgic%20elegant%20composition&width=800&height=450&seq=mitao-v001&orientation=landscape',
    duration: '45:32',
    description: '王家卫导演首次执导电视剧，改编自金宇澄同名小说，以上海为背景，讲述阿宝、沪生、小毛等人在时代浪潮中的命运沉浮。',
    summary: '王家卫首部电视剧，胡歌、马伊琍主演，金宇澄茅盾文学奖获奖作品改编。',
    content: `<p>《繁花》是王家卫导演的首部电视剧作品，改编自金宇澄的同名长篇小说，该小说曾荣获第九届茅盾文学奖。这部剧以20世纪90年代的上海为背景，通过阿宝、沪生、小毛三个不同家庭背景的年轻人视角，展现了那个风云变幻时代中的市井生活、人情冷暖与命运沉浮。</p>
<p>王家卫以其标志性的影像美学赋予这部剧独特的视觉风格，每一帧画面都如同一幅精心构图的摄影作品。胡歌饰演的阿宝，从一个懵懂少年逐渐成长为在商海中沉浮的成熟男人；马伊琍饰演的李李，则以其细腻的表演诠释了知识女性在时代洪流中的挣扎与坚守。</p>
<p>剧中不仅有扣人心弦的商战情节，更有令人动容的情感纠葛。王家卫用他擅长的非线性叙事手法，将过去与现在交织，营造出一种如梦似幻的叙事氛围。</p>`,
    views: 1280000,
    likes: 89600,
    rating: 9.2,
    tags: ['热门推荐', '王家卫', '胡歌', '茅盾文学奖', '上海'],
    publishDate: '2024-12-27',
    isFeatured: true,
    isNew: false,
    author: '蜜桃编辑部',
  },
  {
    id: 'v002',
    title: '《流浪地球3》—— 人类命运共同体的终极抉择',
    slug: 'liulang-diqiu-3',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20scene%20with%20a%20massive%20planet%20engine%20glowing%20blue%20against%20the%20cosmic%20backdrop%2C%20spacecraft%20flying%20near%20a%20frozen%20Earth%2C%20epic%20cinematic%20lighting%2C%20dramatic%20clouds%2C%20atmospheric%20color%20grading%20with%20deep%20blues%20and%20warm%20orange%20accents&width=800&height=450&seq=mitao-v002&orientation=landscape',
    duration: '02:28:15',
    description: '中国科幻电影巅峰之作续集，人类面临前所未有的生存危机，全球团结一致共同面对挑战。',
    summary: '中国科幻巨制，郭帆导演，吴京、刘德华主演，全球票房突破50亿。',
    content: `<p>《流浪地球3》延续了前两部的宏大世界观，将故事推向了一个全新的高度。在地球成功摆脱木星引力危机后，人类面临着太阳氦闪的最终威胁。联合政府必须在有限的时间内做出抉择：是继续推动地球前往比邻星，还是启动"方舟计划"保存人类文明的火种。</p>
<p>郭帆导演在本片中进一步提升了视觉特效的水准，太空场景的震撼程度超越了前作。吴京饰演的刘培强以全新的方式回归，而刘德华饰演的图恒宇则面临着人性与使命的终极考验。</p>
<p>影片不仅有着令人窒息的视觉奇观，更深刻探讨了"人类命运共同体"这一主题。在面对共同的生存危机时，不同国家、不同文化背景的人们如何放下分歧、携手共进，成为影片最动人的内核。</p>`,
    views: 3560000,
    likes: 215000,
    rating: 9.5,
    tags: ['热门推荐', '科幻', '吴京', '刘德华', '国产大片'],
    publishDate: '2025-01-29',
    isFeatured: true,
    isNew: true,
    author: '蜜桃编辑部',
  },
  {
    id: 'v003',
    title: '《乘风破浪的姐姐》第五季 —— 她力量再次绽放',
    slug: 'chengfeng-polang-5',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20glamorous%20stage%20performance%20with%20multiple%20female%20performers%20in%20sparkling%20outfits%2C%20bright%20stage%20lights%20with%20warm%20golden%20and%20pink%20tones%2C%20concert%20atmosphere%2C%20confetti%20falling%2C%20energetic%20dance%20pose%2C%20professional%20stage%20photography&width=800&height=450&seq=mitao-v003&orientation=landscape',
    duration: '01:35:20',
    description: '超人气女性励志综艺第五季重磅回归，三十位姐姐再次集结，用实力与魅力书写属于自己的精彩篇章。',
    summary: '热门综艺第五季，全新阵容精彩对决，姐姐们用实力证明年龄只是数字。',
    content: `<p>《乘风破浪的姐姐》第五季携全新阵容强势回归！本季邀请了三十二位来自不同领域的优秀女性，包括实力派演员、殿堂级歌手、知名主持人以及跨界艺人。她们将在三个月的时间里，通过一次次舞台竞演，重新定义自我、突破极限。</p>
<p>本季赛制全面升级，引入了"队长争夺战"、"奇袭环节"等全新玩法，让比赛更加扣人心弦。每一场公演都堪比顶级演唱会，舞美设计、编曲编排、造型呈现均达到业界顶尖水准。</p>
<p>更令人动容的是姐姐们之间真挚的情谊——从初次见面时的拘谨，到并肩作战后的默契，再到离别时的不舍。这不仅是一场选秀比赛，更是关于女性力量、友谊与成长的动人诗篇。</p>`,
    views: 2890000,
    likes: 178000,
    rating: 9.0,
    tags: ['热门推荐', '综艺', '女性力量', '舞台竞演'],
    publishDate: '2025-05-18',
    isFeatured: true,
    isNew: false,
    author: '蜜桃编辑部',
  },
  {
    id: 'v004',
    title: '《深海》—— 国产动画的视觉革命',
    slug: 'shenhai-donghua',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20animation%20style%20underwater%20scene%20with%20colorful%20sea%20creatures%2C%20bioluminescent%20jellyfish%2C%20deep%20ocean%20with%20rays%20of%20light%20penetrating%20from%20above%2C%20dreamy%20atmosphere%2C%20vibrant%20ink-wash%20painting%20style%20blended%20with%203D%2C%20ethereal%20and%20magical%20mood&width=800&height=450&seq=mitao-v004&orientation=landscape',
    duration: '01:52:00',
    description: '田晓鹏导演七年磨一剑，以极致的水墨粒子特效，呈现了一个令人叹为观止的海底奇幻世界。',
    summary: '国产动画里程碑之作，粒子水墨特效惊艳全球，入围柏林电影节。',
    content: `<p>《深海》是《大圣归来》导演田晓鹏历时七年精心打磨的动画长片。影片首创"粒子水墨"技术，将中国传统水墨画的美学与三维动画完美融合，创造出了前所未有的视觉奇观。每一帧画面都如同流动的水墨画，数十亿个色彩粒子在银幕上舞动，构建出一个绚丽多彩的海底世界。</p>
<p>故事围绕一个深陷抑郁的女孩参宿展开，她在一场奇幻的海底冒险中，遇到了神秘的小丑南河。两人在光怪陆离的深海中经历了种种奇遇，参宿也在这段旅程中逐渐找回了生活的勇气与希望。</p>
<p>影片不仅在技术上实现了重大突破，其深刻的主题——关于抑郁症、关于自我救赎——更是引发了广泛的社会讨论与情感共鸣。</p>`,
    views: 1890000,
    likes: 156000,
    rating: 9.3,
    tags: ['国产动画', '水墨特效', '田晓鹏', '柏林电影节'],
    publishDate: '2025-01-22',
    isFeatured: true,
    isNew: false,
    author: '蜜桃编辑部',
  },
  {
    id: 'v005',
    title: '城市漫步：在成都的街头走一走',
    slug: 'chengdu-street-walk',
    category: '短视频',
    categorySlug: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20warm%20street%20scene%20in%20Chengdu%20China%20with%20traditional%20architecture%2C%20red%20lanterns%2C%20people%20walking%20casually%2C%20teahouse%20culture%2C%20golden%20hour%20sunlight%20filtering%20through%20trees%2C%20relaxed%20lifestyle%20vibe%2C%20travel%20photography%20style%20with%20warm%20tones&width=800&height=450&seq=mitao-v005&orientation=landscape',
    duration: '08:42',
    description: '跟随镜头漫步成都街头，感受这座千年古城的烟火气息与慢生活美学。',
    summary: '成都城市漫步系列，感受最地道的巴蜀文化与美食。',
    content: `<p>成都，一座来了就不想走的城市。这段短视频以第一人称视角，带领观众漫步在成都的大街小巷，从宽窄巷子的青砖黛瓦，到人民公园的盖碗茶香，再到深夜街头串串香的热气腾腾。</p>
<p>短短八分钟的视频，浓缩了成都最动人的生活片段——老茶馆里打麻将的大爷大妈、春熙路上时尚的年轻人、巷子口卖糖油果子的老婆婆……这些平凡的瞬间构成了一幅鲜活的城市生活画卷。</p>
<p>视频配以舒缓的背景音乐和恰到好处的环境音，让观众仿佛身临其境，感受到成都独特的"巴适"生活态度。</p>`,
    views: 560000,
    likes: 42000,
    rating: 9.1,
    tags: ['城市漫步', '成都', '美食', '旅行', '生活方式'],
    publishDate: '2025-06-15',
    isFeatured: false,
    isNew: true,
    author: '城市漫步团队',
  },
  {
    id: 'v006',
    title: '《河西走廊》—— 丝绸之路上的文明交响',
    slug: 'hexi-zoulang',
    category: '纪录片',
    categorySlug: 'jilu',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20epic%20landscape%20of%20the%20Hexi%20Corridor%20in%20Gansu%20China%2C%20vast%20desert%20with%20ancient%20Silk%20Road%20ruins%2C%20sand%20dunes%20under%20golden%20sunset%20light%2C%20dramatic%20clouds%2C%20historical%20caravan%20route%2C%20majestic%20mountain%20range%20in%20distance%2C%20cinematic%20documentary%20photography&width=800&height=450&seq=mitao-v006&orientation=landscape',
    duration: '50:00',
    description: '大型人文历史纪录片，穿越两千年的时光隧道，探寻河西走廊在中国文明进程中的独特地位。',
    summary: '央视大型纪录片，豆瓣评分9.7，讲述丝绸之路上的辉煌历史。',
    content: `<p>《河西走廊》是一部气势恢宏的大型人文历史纪录片，以位于中国西部的重要通道——河西走廊为讲述对象，从政治、军事、经济、文化、宗教等多角度呈现了从汉代开始直至今天，河西走廊及其连接的中国西部的历史。</p>
<p>摄制组历时三年，行程数万公里，采用情景再现的手法，将历史故事以电影化的方式呈现。从张骞出使西域、霍去病大破匈奴，到敦煌莫高窟的开凿、丝绸之路的贸易往来，每一集都是一段荡气回肠的历史传奇。</p>
<p>雅尼创作的主题曲《河西走廊之梦》，以其苍凉悠远的旋律，为这部纪录片增添了无尽的艺术魅力。</p>`,
    views: 920000,
    likes: 78000,
    rating: 9.7,
    tags: ['纪录片', '历史', '丝绸之路', '河西走廊', '高分推荐'],
    publishDate: '2025-03-10',
    isFeatured: false,
    isNew: false,
    author: '蜜桃纪录片频道',
  },
  {
    id: 'v007',
    title: 'NBA季后赛：湖人vs勇士巅峰对决回顾',
    slug: 'nba-lakers-warriors',
    category: '体育',
    categorySlug: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dynamic%20basketball%20game%20scene%20with%20two%20players%20in%20gold%20and%20blue%20jerseys%20competing%20intensely%2C%20dramatic%20arena%20lighting%2C%20sports%20photography%20style%2C%20motion%20blur%20on%20the%20ball%2C%20packed%20stadium%20background%2C%20action-packed%20composition&width=800&height=450&seq=mitao-v007&orientation=landscape',
    duration: '25:18',
    description: 'NBA季后赛西部半决赛精彩集锦，詹姆斯与库里两位超级巨星的巅峰对话。',
    summary: 'NBA季后赛经典战役，詹姆斯vs库里，全程高能不容错过。',
    content: `<p>NBA季后赛西部半决赛，洛杉矶湖人队对阵金州勇士队，这是所有篮球迷期待已久的对决。勒布朗·詹姆斯与斯蒂芬·库里——两位定义了近十年NBA的超级巨星——在季后赛的舞台上再度相遇。</p>
<p>七场大战，每一场都精彩纷呈。从库里单场命中10记三分的疯狂表演，到詹姆斯在关键时刻的统治级发挥，再到角色球员们挺身而出的惊喜时刻，这轮系列赛堪称近年NBA季后赛的经典之作。</p>
<p>本期集锦精选了全系列赛最精彩的高光时刻，配合专业解说和分析，带您重温这场篮球盛宴的每一个精彩瞬间。</p>`,
    views: 1780000,
    likes: 135000,
    rating: 9.4,
    tags: ['NBA', '湖人', '勇士', '詹姆斯', '库里', '季后赛'],
    publishDate: '2025-05-28',
    isFeatured: false,
    isNew: true,
    author: '蜜桃体育频道',
  },
  {
    id: 'v008',
    title: '周杰伦《最伟大的作品》全球巡回演唱会精选',
    slug: 'jay-chou-concert',
    category: '音乐',
    categorySlug: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20grand%20concert%20stage%20with%20dramatic%20lighting%20and%20laser%20effects%2C%20a%20performer%20at%20center%20stage%2C%20massive%20LED%20screen%20background%2C%20cheering%20crowd%20with%20light%20sticks%2C%20epic%20concert%20atmosphere%2C%20warm%20golden%20and%20pink%20stage%20lights%2C%20professional%20concert%20photography&width=800&height=450&seq=mitao-v008&orientation=landscape',
    duration: '18:55',
    description: '周杰伦时隔六年再度开启全球巡演，精选台北、上海、新加坡站最燃现场。',
    summary: '周杰伦全球巡演精选，经典与新作交织，视听盛宴不容错过。',
    content: `<p>华语乐坛天王周杰伦「最伟大的作品」全球巡回演唱会自启动以来，场场爆满、一票难求。本期精选了台北首站、上海站和新加坡站的最精彩片段，让未能到场的歌迷也能感受到现场的震撼。</p>
<p>演唱会以《最伟大的作品》专辑为开场，融合古典与流行、东方与西方的音乐元素。从《青花瓷》的唯美中国风到《双截棍》的炸裂节奏，从写给女儿的新歌到经典情歌串烧，每一首歌都引发了全场万人合唱。</p>
<p>舞台设计更是令人叹为观止——360度旋转舞台、全息投影技术、定制烟花特效，将每一场演出都打造成为独一无二的视听盛宴。</p>`,
    views: 2350000,
    likes: 192000,
    rating: 9.6,
    tags: ['周杰伦', '演唱会', '华语音乐', '最伟大的作品'],
    publishDate: '2025-04-20',
    isFeatured: true,
    isNew: false,
    author: '蜜桃音乐频道',
  },
  {
    id: 'v009',
    title: '《漫长的季节》—— 东北往事与时代悲歌',
    slug: 'manchang-de-jijie',
    category: '电视剧',
    categorySlug: 'dianshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20scene%20of%20northeast%20China%20in%20autumn%2C%20old%20factory%20town%20with%20falling%20leaves%2C%20vintage%201990s%20aesthetic%2C%20warm%20golden%20autumn%20light%2C%20industrial%20heritage%20atmosphere%2C%20melancholic%20mood%2C%20cinematic%20composition%20with%20soft%20color%20grading&width=800&height=450&seq=mitao-v009&orientation=landscape',
    duration: '52:15',
    description: '辛爽导演继《隐秘的角落》后又一力作，范伟、秦昊主演，跨越二十年的悬疑故事。',
    summary: '豆瓣9.4分神剧，范伟秦昊演技炸裂，东北悬疑故事感人至深。',
    content: `<p>《漫长的季节》是导演辛爽继《隐秘的角落》后的又一力作，讲述了发生在东北小城桦林的一段跨越二十年的故事。出租车司机王响（范伟饰）、妹夫龚彪（秦昊饰）和前刑警队长马德胜，三个人因为一桩尘封多年的碎尸案被重新联系在了一起。</p>
<p>剧集采用双线叙事，在1998年和2016年之间自由切换，通过三个"失败者"的视角，展现了个体在时代洪流中的挣扎与坚守。范伟的表演令人惊艳——他褪去了喜剧演员的标签，将王响这个角色演绎得入木三分。</p>
<p>这不仅仅是一部悬疑剧，更是一首献给东北老工业基地的挽歌，一曲关于命运、关于选择、关于"向前看"的生命之诗。</p>`,
    views: 1980000,
    likes: 167000,
    rating: 9.4,
    tags: ['高分推荐', '悬疑', '范伟', '秦昊', '辛爽'],
    publishDate: '2025-02-14',
    isFeatured: false,
    isNew: false,
    author: '蜜桃编辑部',
  },
  {
    id: 'v010',
    title: '《封神第二部》—— 神话史诗的全新篇章',
    slug: 'fengshen-di-er-bu',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20mythological%20battle%20scene%20with%20ancient%20warriors%20in%20armor%2C%20dramatic%20sky%20with%20storm%20clouds%2C%20fantasy%20elements%20with%20glowing%20magical%20weapons%2C%20cinematic%20lighting%2C%20large-scale%20battle%20formation%2C%20Chinese%20mythology%20epic%20style&width=800&height=450&seq=mitao-v010&orientation=landscape',
    duration: '02:35:00',
    description: '乌尔善导演的《封神》三部曲第二部，姬发返回西岐后的故事全面展开，神仙大战震撼来袭。',
    summary: '国产神话史诗续作，太师闻仲率大军征伐西岐，视觉奇观全面升级。',
    content: `<p>《封神第二部》承接第一部结尾，姬发（于适饰）历经千辛万苦返回西岐，然而殷商太师闻仲（吴兴国饰）已率领大军压境。邓婵玉（那尔那茜饰）与魔家四将的登场，让这场正邪之战进入了全新的阶段。</p>
<p>乌尔善导演在第二部中进一步释放了视觉想象力的极限。青云剑、混元伞等神器的视觉呈现令人窒息，而魔家四将与西岐阵营的斗法场景更是将中国神话的想象力推向了银幕极致。</p>
<p>除了震撼的视觉奇观，影片对于"天下共主"这一主题的探讨也更加深刻——谁才有资格成为天下共主？是拥有武力的人，还是心怀天下的人？</p>`,
    views: 4200000,
    likes: 268000,
    rating: 8.8,
    tags: ['国产大片', '神话', '乌尔善', '封神', '视觉奇观'],
    publishDate: '2025-07-18',
    isFeatured: true,
    isNew: true,
    author: '蜜桃编辑部',
  },
  {
    id: 'v011',
    title: '《一年一度喜剧大赛》精选合辑',
    slug: 'xiju-dasai-jingxuan',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20colorful%20comedy%20stage%20with%20performers%20in%20exaggerated%20costumes%2C%20bright%20stage%20lighting%20with%20warm%20tones%2C%20comedic%20expressions%2C%20live%20audience%20laughing%2C%20variety%20show%20atmosphere%2C%20playful%20and%20energetic%20mood&width=800&height=450&seq=mitao-v011&orientation=landscape',
    duration: '35:40',
    description: '年度最受欢迎的喜剧综艺节目，精选本季最爆笑的Sketch短剧和小品表演。',
    summary: '最搞笑的喜剧综艺精选，让你笑到停不下来的精彩作品合集。',
    content: `<p>《一年一度喜剧大赛》已成为国内最具影响力的喜剧综艺IP之一。本期精选合辑收录了本季最受欢迎的十部Sketch短剧和小品作品，涵盖职场、家庭、社会热点等多个主题。</p>
<p>从土豆吕严的荒诞派喜剧到某某某的社会观察式幽默，从少爷和我的素描喜剧到小婉管栎的肢体喜剧——每一种喜剧风格都在这个舞台上找到了属于自己的表达方式。</p>
<p>这些作品不仅能让你笑得前仰后合，更在笑声背后蕴含着对生活的深刻洞察与温暖关怀。</p>`,
    views: 1560000,
    likes: 98000,
    rating: 9.1,
    tags: ['喜剧', '综艺', 'Sketch', '爆笑推荐'],
    publishDate: '2025-06-08',
    isFeatured: false,
    isNew: false,
    author: '蜜桃综艺频道',
  },
  {
    id: 'v012',
    title: '《进击的巨人》最终季完结篇深度解析',
    slug: 'jinji-de-juren-final',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20anime-style%20dramatic%20scene%20with%20a%20colossal%20figure%20against%20a%20burning%20sky%2C%20epic%20scale%2C%20dark%20atmospheric%20mood%2C%20cinematic%20composition%2C%20intense%20drama%2C%20anime%20art%20style%20with%20detailed%20linework%2C%20dramatic%20lighting%20from%20flames&width=800&height=450&seq=mitao-v012&orientation=landscape',
    duration: '28:30',
    description: '现象级动漫作品《进击的巨人》迎来最终完结，深度解析艾伦的选择与自由的真正含义。',
    summary: '《进击的巨人》完结深度解读，从自由到宿命，十年巨作终章。',
    content: `<p>历经十年的连载与动画化，《进击的巨人》终于画上了句号。这期深度解析视频，将带领观众重新审视艾伦·耶格尔的选择，以及谏山创通过这部作品想要传达的终极命题。</p>
<p>从墙壁内的恐惧到海洋另一端的真相，从追求自由到成为自由的囚徒——艾伦的转变是整个故事最核心的悲剧线索。而最终章中"地鸣"的发动，更是将关于战争、仇恨与和解的讨论推向了极致。</p>
<p>无论你对结局持何种态度，不可否认的是，《进击的巨人》已经成为动漫史上最具思想深度和影响力的作品之一。</p>`,
    views: 890000,
    likes: 72000,
    rating: 9.0,
    tags: ['进击的巨人', '动漫解读', '完结', '深度解析'],
    publishDate: '2025-03-22',
    isFeatured: false,
    isNew: false,
    author: '蜜桃动漫频道',
  },
];